import React from "react";
import propTypes from "prop-types";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";

function AlertDialog({ trackingNumber, open, handlerClose ,dataGuia}) {
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  // const handleClose = () => {
  //   setOpen(false);
  // };
  console.log("Si entra aqui")
  console.log(dataGuia)

  return (
    <Dialog
      open={open}
      onClose={handlerClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Tu # de guía es: " + trackingNumber}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Puedes consultar tus guías despues en la sección Envios
        </DialogContentText>

      </DialogContent>
      <DialogActions>
        
        <a
          href={dataGuia[0].label}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button  color="primary" autoFocus  >
          Descargar Guía
          </Button>
          
          </a>
         {dataGuia.billOfLading?(
          <a
          href={dataGuia.billOfLading}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Button  color="primary" autoFocus  >
          Descargar carta porte
          </Button>
          
          </a>  
         ):('')} 
        
        <Button onClick={handlerClose} color="primary" autoFocus>
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  );
}

AlertDialog.propTypes = {
  trackingNumber: propTypes.string,
  open: propTypes.bool,
  handlerClose: propTypes.func
};
export default AlertDialog;
